<template>
      <v-row>
      <v-col md="3">
       <v-card
    height="400"
    width="256"
    class="mx-auto"
  >
    <v-navigation-drawer permanent>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Products List
          </v-list-item-title>
        
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card> 
      </v-col>
      <v-col md="9">
      </v-col>
    </v-row>
</template>
<script>
import StarRating from "vue-star-rating";
import axios from "axios";
import AppSideNav from "@/components/common/AppSideNav";

export default {
  props: ["id"],
  components: {
    AppSideNav,
    StarRating
  },
  data() {
    return {
      data: [],
         items: [
          { title: 'Product List', icon: 'mdi-view-dashboard' },
          { title: 'Pending Product List', icon: 'mdi-image' },
          { title: 'View Products', icon: 'mdi-help-box' },
        ],
        right: null,
      product: {
        name: null,
        price: null,
        desc: null,
        instock: null,
        seller: null,
        id: null,
        status: null
      }
    };
  },
  beforeMount() {
    this.getproducts();
  },
  methods: {
    getproducts() {
      axios({
        method: "GET",
        url: "/product/myproducts/",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.data = Response.data.data;
        this.photos = Response.data.data.photos;

        var tempflag = [];
        for (var i = 0; i < this.photos.length; i++) {
          var tyimg = {
            src: "https://api.inguzsales.in/u/" + this.photos[i],
            // src: $Image_URL + this.regions[i].flag,
            id: this.photos[i]
          };
          tempflag.push(tyimg);
        }
        this.dataImages = tempflag;
      });
    }
  }
};
</script>


